import axiosClient from '@/config/api/axios'
import { CHAT_ARTIFACTS } from '@/config/api/endpoints'
import { isApiConfigured } from '@/config/api/env'

export async function fetchChatArtifacts(chatId, options = {}) {
  if (!isApiConfigured() || !chatId) return []
  const { data } = await axiosClient.get(CHAT_ARTIFACTS, {
    params: { chat_id: chatId },
    signal: options.signal,
  })
  return Array.isArray(data?.artifacts) ? data.artifacts : []
}

export async function fetchChatArtifactAccess(
  chatId,
  artifactId,
  options = {},
) {
  if (!isApiConfigured() || !chatId || !artifactId) return null
  const { data } = await axiosClient.get(`${CHAT_ARTIFACTS}/access`, {
    params: {
      chat_id: chatId,
      artifact_id: artifactId,
      ...(options.inline ? { inline: true } : {}),
    },
    signal: options.signal,
  })
  return typeof data?.url === 'string' && data.url ? data.url : null
}
